import { Capacitor } from '@capacitor/core'

const native = Capacitor.isNativePlatform()
const platform = Capacitor.getPlatform()

/** Runtime capabilities are independent of responsive viewport breakpoints. */
export function usePlatform() {
  return {
    isNative: native,
    platform,
    isIOS: native && platform === 'ios',
    isAndroid: native && platform === 'android',
  }
}

export function applyPlatformPresentation() {
  document.documentElement.dataset.runtime = native ? 'native' : 'web'
  document.documentElement.dataset.platform = platform

  if (native) {
    // Pinch zoom is disabled by Capacitor; constrain WebKit's input-focus zoom too.
    document.querySelector('meta[name="viewport"]')?.setAttribute(
      'content',
      'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover',
    )
  }
}
